module.exports = __webpack_public_path__ + "img/index_img4.6e4a65a3.png";